<template>
  <div class="">
    <div v-if="label" class="label">{{ label }}</div>
    <ValidationProvider
      :name="$attrs.label"
      :rules="rules"
      v-slot="{ errors }"
      :vid="vid"
    >
      <v-textarea
        class="custom-textarea"
        :type="type"
        v-model="innerValue"
        :error-messages="errors"
        v-bind="$attrs"
        v-on="$listeners"
        solo
        dense
        hide-details="auto"
        :height="height"
        @change="emitChange"
        :value="innerValue"
        :disabled="disabled"
        no-resize
      ></v-textarea>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import * as Validator from "vee-validate";

Validator.extend("RegexEmail", {
  message: "Błędny format adresu email. pl|com|eu|uk|net|de|ru|br|fr|it|in",
  validate: (value) => {
    var patt = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+(pl|eu|com|uk|net|de|ru|br|fr|it|in)))$/
    );
    return patt.test(value);
  },
});

export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
    vid: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "text",
    },
    height: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    value(newVal) {
      if (newVal) {
        this.innerValue = newVal.toString().trim();
      } else {
        this.innerValue = newVal;
      }
    },
  },
  methods: {
    emitChange() {
      this.$emit("newValueAfterChange", this.innerValue);
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>

<style scoped>
/* Main wrapper */
.custom-textarea {
  margin: 8px 0;
  box-shadow: none !important;
  border: none !important;
}

/* Base input container */
.custom-textarea >>> .v-input {
  border-radius: 12px;
  background-color: white !important;
  box-shadow: none !important;
  border: none !important;
  outline: none !important;
}

/* Remove all solo and focus container styles */
.custom-textarea >>> .v-input.v-input--solo,
.custom-textarea >>> .v-input.v-input--solo.v-input--is-focused {
  box-shadow: none !important;
  border: none !important;
  outline: none !important;
}

/* Override hover state styles */
.custom-textarea >>> .v-input:hover .v-input__slot {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Input control container */
.custom-textarea >>> .v-input__control {
  border-radius: 12px;
  padding: 0 !important;
  box-shadow: none !important;
  background-color: transparent !important;
  outline: none !important;
}

/* Fix cursor visibility and reduce padding */
.custom-textarea >>> textarea {
  padding: 4px 8px !important; /* Reduced padding */
  color: #6d6963;
  font-size: 12px;
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
  resize: none !important;
  outline: none !important;
  caret-color: auto !important; /* Ensure caret/cursor is visible */
}

/* Label styling */
.custom-textarea >>> .v-label {
  font-weight: 400;
  font-size: 12px;
  color: #6d6963 !important;
  opacity: 1 !important;
  transform: none !important;
  box-shadow: none !important;
  border: none !important;
}

/* Remove any border/outline from the input slot */
.custom-textarea >>> .v-input__slot {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  min-height: auto !important; /* Help with padding issues */
  background-color: white !important; /* Ensure background stays white */
  transition: none !important; /* Remove transitions that might be causing hover effects */
}

/* Remove before/after pseudo elements that might create borders */
.custom-textarea >>> .v-input__slot:before,
.custom-textarea >>> .v-input__slot:after {
  border: none !important;
  background-color: transparent !important;
  outline: none !important;
  display: none !important; /* Completely remove pseudo elements */
}

/* Target all states - normal, hover, focus, active */
.custom-textarea >>> .v-input--is-focused .v-input__slot,
.custom-textarea >>> .v-input:hover .v-input__slot,
.custom-textarea >>> .v-input--is-active .v-input__slot {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  background-color: white !important;
}

/* Additional selector for hover states */
.custom-textarea >>> .v-input:hover {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Eliminate any elevation changes on hover */
.custom-textarea >>> .theme--light.v-text-field--solo:hover .v-input__slot,
.custom-textarea >>> .theme--light.v-textarea--solo:hover .v-input__slot {
  border: none !important;
  box-shadow: none !important;
  elevation: 0 !important;
}

/* Add specific rule to override Vuetify's default elevation on hover */
.custom-textarea >>> .theme--light.v-text-field--solo .v-input__slot,
.custom-textarea >>> .theme--light.v-textarea--solo .v-input__slot {
  box-shadow: none !important;
  elevation: 0 !important;
}

/* Label outside component styling */
.label {
  font-weight: 400;
  font-size: 12px;
  color: #6d6963;
  margin-bottom: 4px;
}
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: #fff;
}
.v-text-field--outlined fieldset{
  border: none !important;
  outline: none !important;
  border-width: 0px !important;
}
</style>
